import React from "react";

import { mdiFormatListBulleted } from "@mdi/js";
import Icon from "@mdi/react";

import type { JSX } from "react";

export default function SequentialRuleIcon(): JSX.Element {
  return (
    <div className="bg-primary/10 overflow-hidden rounded-full">
      <Icon
        className="text-primary p-1.25"
        path={mdiFormatListBulleted}
        size={1.25}
      />
    </div>
  );
}
